import { useMutation, useQueryClient } from "@tanstack/react-query";

import useGetAccessToken from "components/Login/useGetAccessToken";
import { mintShareLink } from "../methods/shareFile";
import { SHARES_QUERY_KEY } from "./shareKeys";

/**
 * Get-or-mint a file's share link (file-api ADR 036), returning its URL. This
 * is a deliberate user action (Create / Copy / Extend) — never fired on open —
 * because minting renews the link's expiry. Refetches the shares list on
 * success so the status line reflects the renewed expiry (and created_at, which
 * the mint response doesn't carry) accurately.
 */
export default function useMintShareLink(fileId: string) {
  const getAccessToken = useGetAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => mintShareLink(fileId, getAccessToken),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SHARES_QUERY_KEY(fileId) });
    },
    onError: (error) => {
      console.error("Failed to mint share link:", error);
    },
  });
}
